import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConfirmDeleteListModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    deletingList: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleDelete() {
      this.$emit("delete-list", this.$refs.modal);
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    handleHidden() {
      this.$emit("hidden");
    }
  }
});